import { QueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";

/**
 * Everything a write to `list_members` can change, invalidated in one call.
 *
 * Sharing touches four caches at once — who the Members are, the Owner's
 * manage panel, which Lists you can see, and which Tasks come with them —
 * and each of the five sharing mutations used to spell that set out for
 * itself. They drifted: an invite forgot the "shared" mark, and an accept
 * or a Leave left the Owner's panel showing the old membership. One list
 * that every caller shares is what stops the next one drifting again.
 *
 * `listId` is omitted only by the realtime handler, which is told that
 * `list_members` changed but not which List — so it refreshes every manage
 * panel it has cached rather than guessing.
 */
export function invalidateSharingQueries(
  queryClient: QueryClient,
  listId?: string,
): void {
  queryClient.invalidateQueries({ queryKey: queryKeys.listMembers });
  queryClient.invalidateQueries({
    queryKey: listId
      ? queryKeys.listMemberDirectory(listId)
      : queryKeys.listMemberDirectories,
  });
  queryClient.invalidateQueries({ queryKey: queryKeys.lists });
  queryClient.invalidateQueries({ queryKey: queryKeys.tasks });
}
